module.exports = __webpack_public_path__ + "static/media/stat-2.23ee0308.svg";